import * as L from 'leaflet';

/**
 * The app's one map pin silhouette — a teardrop, on a `0 0 24 33` viewBox.
 * Originally specced for the Monitor page's fleet-status pins
 * (`design_handoff_monitor_fleet/README-2a-map-tab.md`), now used for every
 * pin app-wide (including plain single-location markers) so all maps read
 * as the same visual language, not just Monitor's.
 */
export const PIN_BODY_PATH =
  'M12 1.6c-5.2 0-9.4 4.1-9.4 9.2 0 6.6 9.4 20.2 9.4 20.2s9.4-13.6 9.4-20.2c0-5.1-4.2-9.2-9.4-9.2z';

/**
 * Builds a teardrop `divIcon`. `inner` is arbitrary SVG markup drawn inside
 * the pin's head — a status glyph, a cluster count, or omitted for a plain
 * single-location pin. `ring` draws the accent selection ring under the
 * body (Monitor's selected-pin treatment); most callers won't need it.
 */
export function createPinDivIcon(options: {
  width: number;
  height: number;
  fill: string;
  inner?: string;
  ring?: boolean;
  className?: string;
}): L.DivIcon {
  const { width, height, fill, inner = '', ring = false, className = 'pc-map-pin' } = options;
  const ringMarkup = ring
    ? `<path d="${PIN_BODY_PATH}" fill="none" stroke="#007FE9" stroke-width="3.4"/>`
    : '';
  const svg = `
    <svg width="${width}" height="${height}" viewBox="0 0 24 33" xmlns="http://www.w3.org/2000/svg">
      ${ringMarkup}
      <path d="${PIN_BODY_PATH}" style="fill:${fill}" stroke="#fff" stroke-width="2"/>
      ${inner}
    </svg>`;
  return L.divIcon({
    html: svg,
    className,
    iconSize: [width, height],
    iconAnchor: [width / 2, height],
    popupAnchor: [0, -height + 8],
  });
}
